import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import AddUserButtonContainer from './addUserButton';
import SelectedUsersActions from './selectedUsersActions';
import { ExportCSVButton, UsersTotalCount } from './toolBarButtons';

@inject('translationsStore', 'usersStore', 'usersGridStore') @observer
export default class UsersTableToolbar extends Component {

    t = this.props.translationsStore.translate;

    render() {
        const { users } = this.props.usersStore;
        
        if (users == null) {  
            return null;
        }

        const { filteredUsers, selectedRows } = this.props.usersGridStore;

        let totalUserCount = users.length;
        let allUsersText = this.t('USERS');
        let filteredUsersNum = filteredUsers ? filteredUsers.length : null;

        if (filteredUsersNum != null && filteredUsersNum > -1 && filteredUsersNum != totalUserCount) {         
            allUsersText = allUsersText + ' (' + filteredUsersNum + '/' + totalUserCount + ')';
        }
        else {
            allUsersText = allUsersText + ' (' + totalUserCount + ')';
        }

        return (<div className='table-toolbar-wrapper'>
                    <div className='table-toolbar'>
                        <UsersTotalCount
                            allUsersText={allUsersText}
                            className='total-users-wrapper' />
                        {selectedRows.length > 0 ? <SelectedUsersActions toolBarProps={this.props}/> : null}
                        <div className='buttons-wrapper'>
                                <ExportCSVButton
                                    component={this.props.components.exportCSVBtn}
                                    className='export-csv-button'
                                    exportCSVText={`${this.t('EXPORT')} CSV`} />
                                <AddUserButtonContainer
                                    className='add-user-button'
                                    addUserText={this.t('ADD_USER')}
                                    addNewUserText={this.t('ADD_NEW_USER')} />
                                { this.props.components.searchField }
                            </div>
                        </div>
                    <br/>
                </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/users/usersTableToolbar.jsx